<div class="padded-page">
  <h1>Page Title</h1>
  <ul class="breadcrumbs">
    <li>BreadCrumbs</li>
    <li><a href="">Crumb 1</a></li>
    <li><a href="">Crumb 2</a></li>
    <li>Crumb 3</li>
  </ul>
  <h2>Primary Header</h2>
  <h3>Subheader</h3>
  <h4>Content Label</h4>
  <label>Content Label as Label</label>
  <p>Paragraph 1</p>
  <p class="secondary">Paragraph 2</p>
  <span class="hint-text">Hint Text</span>
  <span class="caption-text">Caption Text</span>
</div>
